import React from 'react'

const Why = () => {
  return (
    <div className='why'>
        <img src="https://res.cloudinary.com/defcamc5x/image/upload/v1761239060/wcmnxbmzfgeggowssqva.png" className='dec' alt="" />
        <img src="https://res.cloudinary.com/defcamc5x/image/upload/v1761239060/wcmnxbmzfgeggowssqva.png" className='dec2' alt="" />
              <div className="mainTitle">
                <div className="lines">
                <div className="line"></div>
                <div className="line"></div>
    <div className="title">
       <h2>لماذا نحن</h2>
    </div>
            </div>
        </div>
        <div className="container">
            <div className="mainContent">
                <div className="right">
                    <div className="boxs">
                        <div className="box">
                            <img src="https://res.cloudinary.com/defcamc5x/image/upload/v1761248543/hhzfnu5xvf6xkrvadvdm.png" alt="" />
                            <p>خبرة وتميّز</p>
                            </div>
                        <div className="box">
                            <img src="https://res.cloudinary.com/defcamc5x/image/upload/v1761249272/z1hli5dtyvclkmu1ackk.png" alt="" />
                            <p>التزام ومصداقية</p>
                        </div>
                        <div className="box">
                            <img src="https://res.cloudinary.com/defcamc5x/image/upload/v1761249375/ffnvlbtlipfm9lt9ge6j.png" alt="" />
                            <p>احترافية عالية</p>
                        </div>
                        <div className="box">
                            <img src="https://res.cloudinary.com/defcamc5x/image/upload/v1761249468/ebil42iobrqbiiw0c79n.png" alt="" />
                            <p>نتائج مضمونة</p>
                        </div>
                    </div>
                </div>
                <div className="left"><img src="https://res.cloudinary.com/defcamc5x/image/upload/v1761247158/ljlqeni1h359sx5v9dxb.webp" alt="" /></div>
            </div>
        </div>
    </div>
  )
}

export default Why